<template>
	<div class="owl-carousel">
		<div class="item" v-for="item in items">
			<div class="containerItem">
				<div class="top">
					<a :href="item.href_img" class="topBlock" :style='`background-image: url("${item.img}")`'></a>
				</div>
				<div class="bottom">
					<a :href="item.href_name" class="ttl" v-if="item.header" v-html="item.header"></a>
					<div class="priceAndBuy">
						<div class="priceContainer">
							<p class="sale" v-if="item.sale" v-html="item.sale"></p>
							<p v-if="item.oldPrice" v-html="item.oldPrice" class="oldPrice"></p>
							<p v-if="item.price" v-html="item.price" class="price"></p>
						</div>
						<a class="buy waves-effect waves-light sale" :href="item.href_button">
							<svg fill="#FFFFFF" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
								<path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/>
								<path d="M0-.25h24v24H0z" fill="none"/>
							</svg>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
module.exports = {

	props: ['items'],

	data () {
		return {}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 3 ? true : false,
				nav: true,
				dots: true,
				margin: 30,
				responsive: {
					0: {
						items: 1,
					},
					1024: {
						items: 2,
					},
					1180: {
						items: 3,
					}
				}
			}
		});
	}
}
</script>

<style lang="scss" >
@import "scss/wanted";
.slider-catalogVuesliderToSections {
	padding-bottom: 72px;
	.owl-carousel {
		padding: 0 2px;
		position: relative;
		padding-bottom: 70px;
		.owl-stage-outer{
		}
		// .item {
		// 	padding-right: 1px;
		// 	.containerItem{
		// 		.image{
		// 			width: 62px;
		// 			height: 62px;
		// 			max-width: 62px;
		// 			min-width: 62px;
		// 			display: inline-flex;
		// 			border: 1px solid black;
		// 			border-radius: 50%;
		// 			background-size: 29px 29px;
		// 			background-repeat: no-repeat;
		// 			background-position: center;
		// 		}
		// 		.top{
		// 			display: flex;
		// 			justify-conent: center;
		// 			align-items: center;
		// 			border: 1px solid #e2edf3;
		// 			box-shadow: 0px -3px 2px #e2edf3;
		// 			border-bottom: 2px dotted #eaf1f6;
		// 			border-radius: 5px;
		// 			position: relative;
		// 			z-index: 11;
		// 			height: 130px;
		// 			align-items: center;
		// 			.image{
		// 				margin-right: 20px;
		// 				margin-left: 30px;
		// 				margin-right: 30px;
		// 			}
		// 			.header{
		// 				max-width: 150px;
		// 				font-family: $ProximaNova_bold;
		// 				font-size: rem(15);
		// 				line-height: rem(24);
		// 				max-height: rem(96);
		// 				overflow: hidden;
		// 				color: black;
		// 			}
		// 		}
		// 		.bottom{
		// 			border: 1px solid #e2edf3;
		// 			box-shadow: 0px 0px 2px #e2edf3;
		// 			border-radius: 5px;
		// 			position: relative;
		// 			top: -1px;
		// 			z-index: 0;
		// 			padding-bottom: 30px;
		// 			&:after{
		// 				content: "";
		// 				width: 98%;
		// 				position: absolute;
		// 				top: -2px;
		// 				left: 3px;
		// 				right: 0;
		// 				height: 2px;
		// 				background: #fff;
		// 			}
		// 		}
		// 		.text{
		// 			padding-top: 22px;
		// 			padding-left: 30px;
		// 			padding-right: 30px;
		// 			font-size: rem(14);
		// 			line-height: rem(20);
		// 			color: rgba(#000000, .9);
		// 			height: rem(82);
		// 			overflow: hidden;
		// 		}
		// 		.button{
		// 			text-decoration: none;
		// 			border-radius: 50px;
		// 			min-height: 42px;
		// 			height: 42px;
		// 			padding: 0 25px;
		// 			display: inline-flex;
		// 			justify-content: center;
		// 			align-items: center;
		// 			margin-left: 30px;
		// 			margin-top: 23px;
		// 			font-size: rem(16);
		// 			border-width: 1px;
		// 			border-style: solid;
		// 			@include single-transition();
		// 			border-width: 1px;
		// 			border-style: solid;
		// 			&:hover{
		// 				color: #fff;
		// 			}
		// 		}
		// 	}
		// }
		.item {
			padding: 0px 0px;
			background-color: transparent;
			width: 100%;
			padding-right: 2px;
			.wr{
				position: relative;
				background-color: transparent;

				&:after{
					position: absolute;
					top: 0;
					right: 0;
					bottom: 0;
					left: 0;
					z-index: -1;
					content: '';
					border-radius: 5px;
					box-shadow: 0px 3px 5.88px 0.12px rgba(226, 237, 243, 0.5);
				}
			}
			.top{
				border: 1px solid #e2edf3;
				box-shadow: 0px -3px 2px #e2edf3;
				border-bottom: 2px dotted #eaf1f6;
				border-radius: 5px;
				position: relative;
				z-index: 11;
			}
			.topBlock{
				display: block;
				height: 228px;
				background-position: center;
				background-repeat: no-repeat;
				position: relative;
				background-size: auto 165px;
				background-position: center;
			}

			.bottom{
				padding: rem(19) rem(29);
				height: 150px;
				border: 1px solid #e2edf3;
				border-radius: 5px;
				border-top: none;
				border-top-right-radius: 0;
				border-top-left-radius: 0;
				background-color: white;
				border: 1px solid #e2edf3;
				box-shadow: 0px 0px 2px #e2edf3;
				border-radius: 5px;
				position: relative;
				top: -1px;
				z-index: 0;
				padding-bottom: 30px;
				&:after{
					content: "";
					width: 98%;
					position: absolute;
					top: -2px;
					left: 3px;
					right: 0;
					height: 2px;
					background: #fff;
				}
				.ttl{
					font-size: rem(14);
					line-height: rem(27);
					height: rem(54);
					overflow: hidden;
					color: black;
					text-decoration: none;
					margin-bottom: 4px;
					padding: 0;
					font-family: $ProximaNova_bold;
					display: block;
					&:hover{
						text-decoration: underline;
					}
				}
				.priceAndBuy{
					display: flex;
					justify-content: space-between;
					.priceContainer{
						.oldPrice{
							font-size: rem(13);
							line-height: rem(20);
							height: rem(20);
							color: #7e8183;
							b{
								font-weight: normal;
								text-decoration: line-through;
							}
							i{
								font-style: normal;
								font-size: rem(11);
							}
						}
						.sale{
							font-size: rem(13);
							font-family: $ProximaNova_regular;
							height: rem(20);
							b{
								font-weight: normal;
								/* color: #de4b39; */
							}
							i{
								font-style: normal;
								font-size: rem(11);
								/* color: #de4b39; */
							}
						}
						.price{
							font-size: rem(20);
							line-height: rem(20);
							height: rem(20);
							color: #000;
							font-family: $ProximaNova_bold;
							@include l_up{
								font-size: rem(18);
								margin-top: -4px;
							}
							@include l__up{
								font-size: rem(20);
								margin-top: 0px;
							}
							b{
								font-weight: normal;
							}
							i{
								font-style: normal;
								font-size: rem(14);
							}
						}
					}
					.buy{
						width: 43px;
						height: 43px;
						display: flex;
						align-items: center;
						justify-content: center;
						border-radius: 100%;
						text-align: center;
						font-size: rem(16);
						line-height: 43px;
						/* background-color: #fec500; */
						text-decoration: none;
						color: #fff;
						margin: auto;
						margin-right: 0;
						@include single-transition();
						/* &:hover{
							background-color: darken(#fec500, 5%);
						} */
						// @include l_up{
						// 	font-size: rem(16);
						// 	width: 110px;
						// }
						// @include l__up{
						// 	font-size: rem(16);
						// 	width: 120px;
						// }
						/* &.sale{
							background: #de4b39;
							color: #fff;
							&:hover{
								background-color: darken(#de4b39, 12%);
							}
						} */
					}
				}
			}
		}
		.owl-dots{
			position: absolute;
			display: flex;
			align-items: center;
			height: 30px;
			width: 100%;
			bottom: 0;
		}
		.owl-dots{
			justify-content: flex-strat;
			padding-bottom: 3px;
			.owl-dot{
				display: flex;
				width: 12px;
				height: 12px;
				margin-right: 10px;
				justify-content: center;
				align-items: center;
				border-radius: 50%;
				transition: 0.4s ease-in-out;
				border: 1px solid black;
				position: relative;
				span{
					transition: 0.4s ease-in-out;
					width: 6px;
					border-radius: 50%;
					height: 6px;
					background-color: transparent;
					display: inline-block;
					position: absolute;
					margin: 0 auto;
					top: calc(50% - 3px);
					left: calc(50% - 3px);
				}
				&.active{
					border-width: 1px;
					border-style: solid;
				}
			}
		}
		.owl-nav{
			font-size: 0;
			display: flex;
			justify-content:space-between;
			width: 100px;
			position: absolute;
			right: 0;
			bottom: -34px;
			z-index: 5;
			div{
				width: 42px;
				height: 42px;
				border-radius: 100%;
				@include single-transition();
				background-size: 25px;
				background-position: center;
				background-repeat: no-repeat;
				background-image: url('../img/arr.svg');
				border: 1px solid black;
				background-color: #fff;
				&:hover{
					background-image: url('../img/arr2.svg');
				}
			}
			.owl-prev{
				bottom: 30px;
				transform: rotate(90deg);
				position: relative;
				left: 0;
			}
			.owl-next{
				bottom: 30px;
				transform: rotate(-90deg);
				position: relative;
				right: 0;

			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// catalogVuesliderToSections.vue?b476dc12